import {
   TContentDefinition,
   TContentKind,
} from '../../interfaces/campaign-v2.types'

/** A fresh definition for "write your own", per kind. */
export const blankDefinition = (
   kind: TContentKind,
   name: string,
   businessTypeId: number,
   direction: 'outbound' | 'inbound' = 'outbound',
   callerType: 'ai' | 'human' = 'ai'
): TContentDefinition => {
   switch (kind) {
      case 'strategy':
         return {
            name,
            businessTypeId,
            sms: [{ template: '' }],
            email: [],
            voicemail: [],
         }
      case 'phone':
         return {
            name,
            businessTypeId,
            callType: direction,
            callerTypes: [callerType],
            callDirections: [direction],
            leadTypes: ['known'],
            firstMessage: '',
            sections: [
               {
                  name:
                     direction === 'inbound'
                        ? 'Help the caller'
                        : 'Conversation',
                  type:
                     direction === 'inbound' ? 'call_inbound' : 'call_outbound',
                  order: 1,
                  content: '',
               },
            ],
         }
      case 'conversation':
         return { name, businessTypeId, content: '' }
      case 'persona':
         return {
            name,
            businessTypeId,
            guidance: {
               personaGuidance: '',
               voiceStyle: null,
               speakingGuidance: null,
               conversationStyle: null,
            },
         }
   }
}
